
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[courseId]",
      function () {
        return require("private-next-pages/courses/[courseId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/[courseId]"])
      });
    }
  